import React, { useEffect, useState } from 'react';
import { ICreateProfile } from '../@types';
import Navigation from '../components/auth/Navigation';
import StepContent from '../components/auth/stepContent';



const OnboardingScreen: React.FC = () => {
    const [activeStep, setActiveStep] = useState(0);

    return (
        <div className="flex min-h-screen">
            <div className=' hidden md:block w-full xl:w-[30%] md:w-[40%] lg:w-[40%] biglg:w-[30%]'>
            <Navigation activeStep={activeStep} />
            </div>
            <div className='bg-[#F2F9FD] xl:w-[70%] min-h-[150vh] md:w-[60%] lg:w-[60%] biglg:w-[70%] w-full' >
            <StepContent activeStep={activeStep} setActiveStep={setActiveStep} />
            </div>
        </div>
    );
}

export default OnboardingScreen;